import { render, staticRenderFns } from "./TransportEditor.vue?vue&type=template&id=3c3a5e58"
import script from "./TransportEditor.vue?vue&type=script&lang=js"
export * from "./TransportEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports